import { Module, Mutation, Action } from 'vuex-module-decorators'
import { SystemParameterKey, systemParameterKeyApi } from '@/api'
import { defaultSystemParameterKey } from '@/api/models/system-parameter/SystemParameterKey'
import BaseStore from '@/store/BaseStore'
import { find } from 'lodash'

@Module({
  name: 'SystemParameterKeyStore',
  namespaced: true,
  stateFactory: true
})
export default class SystemParameterKeyStore extends BaseStore {
  item: SystemParameterKey = defaultSystemParameterKey()

  items: SystemParameterKey[] = []

  get getItem(): SystemParameterKey {
    return this.item
  }

  get allItems(): SystemParameterKey[] {
    return this.items
  }

  get findByCodeKey(): (codeKey: string) => SystemParameterKey {
    return codeKey => {
      return (
        find<SystemParameterKey>(this.items, { key: codeKey }) ??
        defaultSystemParameterKey()
      )
    }
  }

  @Mutation
  public setItem(SystemParameterKey: SystemParameterKey) {
    this.item = SystemParameterKey
  }

  @Mutation
  public setItems(SystemParameterKeys: SystemParameterKey[]) {
    this.items = SystemParameterKeys
  }

  @Mutation
  public updateItems(systemParameterKey: SystemParameterKey) {
    this.items.some((item, index) => {
      if (item.id === systemParameterKey.id) {
        // TODO 直接代入だと算出プロパティが反応せず、下記コードで反応するようになった
        // 解決した事項だが、原因が良く分からないのでコメントしておく
        this.items.splice(index, 1, systemParameterKey)
        return true
      }
    })
  }

  @Action
  public async fetch(id: number) {
    const key = await systemParameterKeyApi.getSystemParameterKey(id)
    this.setItem(key)
  }

  @Action
  public async fetchAll() {
    const systemCodes = await systemParameterKeyApi.getSystemParameterKeys()
    this.setItems(systemCodes)
  }
}
